import { createAction } from 'redux-actions';
import { SubmissionError } from 'redux-form';
import { UserApi, SecureApi } from 'libs/api';
import * as types from '../constants/actionTypes';

const submitAction = createAction(types.FORGOT_PASSWORD, async (email) =>
    UserApi.forgotPassword(email).then((data) => ({
        email,
        message: data.Message,
    })),
);

const submitUsernameAction = createAction(types.FORGOT_PASSWORD_FOR_USERNAME, async (username) => {
    const data = await SecureApi.forgotPasswordForUsername(username);

    if (!data.Valid) {
        throw new SubmissionError({
            _error: data.Reason,
        });
    }
    return {
        email: data.Email,
        valid: data.Valid,
        reason: data.Reason,
        reasonCode: data.ReasonCode,
        message: data.Message,
    };
});

export { submitAction, submitUsernameAction };
